import {
  blue,
  blueDark,
  blueLight,
  cyan,
  error,
  fuchsia,
  gray,
  grayBlue,
  grayCool,
  grayIron,
  grayModern,
  grayNeutral,
  grayTrue,
  grayWarm,
  green,
  greenLight,
  indigo,
  moss,
  orange,
  orangeDark,
  pink,
  primary,
  purple,
  rose,
  success,
  teal,
  violet,
  warning,
  yellow,
} from "configs/colors";
import { HTMLFontSize } from "configs/variables";

/**
 * Convert from "pixel" to "rem"
 */
export const rem = (fs: number) => `${fs / HTMLFontSize}rem`;

/**
 * Convert from "pixel" to "lineHeight"
 */
export const lineHeight = (
  fs: number,
  basedOnRem: boolean | undefined = true
) => `${fs / HTMLFontSize}${basedOnRem ? "rem" : ""}`;

export const randomColor = (
  variant?: 25 | 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950
) => {
  const colors = [
    blue,
    blueDark,
    blueLight,
    cyan,
    error,
    fuchsia,
    gray,
    grayBlue,
    grayCool,
    grayIron,
    grayModern,
    grayNeutral,
    grayTrue,
    grayWarm,
    green,
    greenLight,
    indigo,
    moss,
    orange,
    orangeDark,
    pink,
    primary,
    purple,
    rose,
    success,
    teal,
    violet,
    warning,
    yellow,
  ];
  const variants = [25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];
  const colorIndex = Math.floor(Math.random() * colors.length);
  const color = colors[colorIndex];
  const variantIndex = Math.floor(Math.random() * variants.length);
  const colorVariant = variant ?? variants[variantIndex];
  return (color as Record<string, string>)[colorVariant];
};
